import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, Container, Row } from "react-bootstrap";
import productGroupImage from "../../Assets/images/productsGroup.png";
import microsoft_authorized_reseller from "../../Assets/images/microsoft_authorized_reseller.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiBaseURL } from "../../Common/ApiHelper";
import { ToastContainer, toast } from "react-toastify";

const Category = ({ item }) => {
  const navigate = useNavigate();
  const [category, setCategory] = useState(`${item.name}`);
  const [loading, setLoading] = useState(true);
  const [added, setAdded] = useState(
    localStorage.getItem("addedProducts")
      ? localStorage.getItem("addedProducts")
      : []
  );
  const [cart, setCart] = useState([]);
  const [products, setProducts] = useState([]);
  const getCategoryById = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${apiBaseURL}user/getCategoryByGroup?categoryId=${item._id}`,
      });
      if (response.status === 200) {
        setProducts(response.data.data);
        setLoading(false);
      }
    } catch (e) {
      console.log("error", e);
      setLoading(false);
    }
  };
  const handleCategory = (e) => {
    navigate(`/category/${e.target.innerText.replace(/\s+/g, "")}`);
  };
  useEffect(() => {
    if (localStorage.getItem("cartItems")) {
      setCart(JSON.parse(localStorage.getItem("cartItems")));
    } else {
      localStorage.setItem("cartItems", JSON.stringify([]));
    }
  }, []);
  useEffect(() => {
    getCategoryById();
    setCategory(item.name);
  }, [item]);

  const handleAddCart = (product) => {
    product.quantity = 1;
    localStorage.setItem("cartItems", JSON.stringify([...cart, product]));
    setCart([...cart, product]);
    const updatedArray = JSON.parse(localStorage.getItem("cartItems")).map(
      (items) => items._id
    );
    setAdded(updatedArray);
    localStorage.setItem("addedProducts", JSON.stringify(updatedArray));
    toast.info("Product Added", {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "light",
    });
    navigate(`${window.location.pathname}`);
  };
  return (
    <>
      <ToastContainer />
      <div className="main pt-4 pb-5">
        <Container>
          <div className="product_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Shop</Breadcrumb.Item>
            </Breadcrumb>
            <button className="blue_bg best_seller_btn">Best Seller</button>
          </div>
          {loading ? (
            <>
              <div class="d-flex justify-content-center ">
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
                <div class="spinner-grow text-secondary mx-1" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="product_details_with_image box_shadow">
                <Row>
                  <Col xxl="3" lg="3" md="12">
                    <div className="product_image pt-4">
                      <img
                        src={products[0]?.documents[0].productImage}
                        alt="Product"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Col>
                  <Col xxl="7" lg="7" md="12">
                    <div className="product_details pt-5 pb-4">
                      <h1>
                        {products[0]?.documents[0].device ? (
                          <>
                            <h1>
                              {products[0]?.documents[0].name.split("For")[0]}
                              <span className="other_product_title">
                                {products[0]?.documents[0].device}
                              </span>
                            </h1>
                          </>
                        ) : (
                          products[0]?.documents[0].name
                        )}
                      </h1>
                      <p className="retail_version_color">
                        Retail Version |{" "}
                        {products[0]?.documents[0]?.retailVersion[0]
                          ?.split(":")
                          .join(": ")}
                      </p>
                      <img
                        src={productGroupImage}
                        alt="Product inner products images"
                        className="mb-4"
                      />

                      <div className="include_product_purchase">
                        <h1 className="font-weight-bold">
                          Included In Your Purchase:
                        </h1>
                        <p>
                          Classic 2021 Versions Of Word, Excel, Outlook, and
                          Powerpoint, and more <br />
                          Microsoft Office 2021 Professional License Key <br />
                          PDF - Download & Activation Guide <br />
                          Live Chat Support & Assistance
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col xxl="2" lg="2" md="12">
                    <div className="price_details pt-5 pb-4">
                      <p className="font-weight-bold product_price mb-0">
                        ${products[0]?.documents[0].salePrice} USD
                      </p>
                      {added.includes(products[0]?.documents[0]._id) ? (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() => navigate("/cart")}
                        >
                          Go To Cart
                        </button>
                      ) : (
                        <button
                          className="product_page_addCart_btn box_shadow"
                          onClick={() =>
                            handleAddCart(products[0]?.documents[0])
                          }
                        >
                          Add To Cart
                        </button>
                      )}

                      <div className="product_have_questions">
                        <h3>Have Questions?</h3>
                        <p>
                          Call +1 (833) 465 0300 <br /> or contact us via chat
                        </p>
                      </div>
                      <div className="microsoft_partner">
                        <img
                          src={microsoft_authorized_reseller}
                          alt="productgroupImg"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          )}

          <div className="shop_categories_wrapper mt-5 mb-4">
            <Row>
              <Col xxl="3" lg="3" sm="12">
                <div className="categories">
                  <div className="product_variation shop_title blue_bg box_shadow mb-3">
                    Categories
                  </div>
                  <div className="cat_items white_bg box_shadow mb-5">
                    <p
                      onClick={handleCategory}
                      className={
                        category === "Microsoft Office"
                          ? "top_radius active_btn"
                          : ""
                      }
                    >
                      Microsoft Office
                    </p>
                    <p
                      onClick={handleCategory}
                      className={
                        category === "Office For Mac" ? "active_btn" : ""
                      }
                    >
                      Office For Mac
                    </p>
                    <p
                      onClick={handleCategory}
                      className={
                        category === "Windows Operating System"
                          ? "bottom_radius active_btn"
                          : ""
                      }
                    >
                      Windows Operating System
                    </p>
                  </div>
                </div>
                <div className="product_sidebar_widget blue_bg box_shadow m-0">
                  <h4>256-bit SSL Encrypted Checkout</h4>
                  <p>
                    All personal information is protected by state of the art
                    SSL certified encryption.{" "}
                  </p>
                  <hr />
                  <h4>24/7 Tech Support Available</h4>
                  <p>
                    Your purchase with Liberty Programs includes around the
                    clock support from our technical experts. <br />
                    <br />
                    Our team of highly trained professionals make software
                    installations a breeze, helping to identify problems and
                    provide immediate solutions that may arise during and after
                    the installation of software.
                  </p>
                  <hr />
                  <h4>Your Business Is Important To Us</h4>
                  <p>
                    We value our customers and appreciate your business with us.
                    <br />
                    <br />
                    Whether you're an individual upgrading your software or a
                    business upgrading their network, we're here 24/7 to provide
                    hands on support and troubleshooting.
                    <br />
                    <br />
                    All software downloads are provided directly from Microsoft
                    with a genuine license key for activation. <br />
                    <br />
                    If you have any concerns regarding the authenticity of your
                    software, please call (833) 465 0300 or contact us via chat
                  </p>
                  <hr />
                  <h4>90-Day Money Back Guarantee</h4>
                  <p>
                    If for any reason you are not completely satisfied with your
                    purchase from us please contact our refund department
                    directly at sales@libertyprograms.com
                    <br />
                    <br />
                    If we cannot resolve your ticket, a full refund will be
                    issued regardless of our 90-day money back guarantee. <br />
                    <br />
                    Terms & conditions apply.
                  </p>
                </div>
              </Col>

              <Col xxl="9" lg="9" sm="12">
                <div className="cat_products ms-3">
                  {products.map((items) => {
                    return (
                      <>
                        <div className="cat_product_item">
                          <Row>
                            <Col xxl="12" md="12">
                              <div className="product_variation shop_title blue_bg box_shadow d-flex justify-content-center">
                                {items._id.subCategoryName}
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            {items.documents.map((products, index) => {
                              return (
                                <>
                                  <Col xxl="4" md="4" className="my-5">
                                    <div
                                      className="box_shadow product_col container_box"
                                      key={index}
                                    >
                                      <div className="Prod_img_container mb-3">
                                        <img
                                          src={products.productImage}
                                          alt="product"
                                          className="product_image mb-5 w-100 word-wrap"
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            navigate(
                                              `/product/${products.name.replace(
                                                /\s+/g,
                                                ""
                                              )}`
                                            )
                                          }
                                        />
                                      </div>

                                      <div>
                                        <div>
                                          <h3 className="product_name mb-0 mt-2">
                                            {products.device ? (
                                              <>
                                                {products.name.split("For")[0]}{" "}
                                                <br />
                                                <span className="other_product_title">
                                                  {products.device}
                                                </span>
                                              </>
                                            ) : (
                                              products.name
                                            )}
                                          </h3>
                                        </div>
                                        <p className="mb-0">
                                          Retail Version |{" "}
                                          <br className="card_break" />
                                          {products?.retailVersion[0]
                                            ?.split(":")
                                            .join(": ")}
                                        </p>
                                        <p className="mb-2">
                                          Includes:{" "}
                                          <br className="card_break" /> Download
                                          + License Key
                                        </p>
                                        <p className="product_price ">
                                          Price: <br />
                                          {products.price > 0 ? (
                                            <span className="discounted_price">
                                              ${products.price}USD
                                            </span>
                                          ) : (
                                            ""
                                          )}
                                          <span>${products.salePrice} USD</span>
                                        </p>
                                        {added.includes(products._id) ? (
                                          <button
                                            className="add_cart_btn"
                                            onClick={() => navigate("/cart")}
                                          >
                                            Go To Cart
                                          </button>
                                        ) : (
                                          <button
                                            className="add_cart_btn"
                                            onClick={() =>
                                              handleAddCart(products)
                                            }
                                          >
                                            Add To Cart
                                          </button>
                                        )}

                                        <button
                                          className="view_product_btn"
                                          onClick={() =>
                                            navigate(
                                              `/product/${products.name.replace(
                                                /\s+/g,
                                                ""
                                              )}`
                                            )
                                          }
                                        >
                                          View Product
                                        </button>
                                      </div>
                                    </div>
                                  </Col>
                                </>
                              );
                            })}
                          </Row>
                        </div>
                      </>
                    );
                  })}
                  <Col xxl="8" md="8" className="cat_product_item">
                    <div className="multi_devices_outer box_shadow mt-4">
                      <h3 className="mb-4">Looking For Multile Devices?</h3>
                      <p>
                        We offer exclusive pricing to companies looking to
                        upgrade their network, no matter the size. From small
                        business owners to government bodies, we're here to help
                        you select the right software you need to suceed.
                        <br />
                        <br />
                        Please contact our sales team to request a free no
                        obligation consulation. We would be happy to earn your
                        business and get your whole network up and running with
                        minimal down time.
                        <br />
                        <br />
                        We specialize in everything from operating systems,
                        productivity apps, and servers that your business
                        requires to complete everyday tasks.{" "}
                      </p>
                    </div>
                  </Col>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Category;
